import Since from "@/components/ui/since";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { display_owner, display_user } from "@/components/utils/display";
import { useUser } from "@/providers/user";
import { PreConfiguredRegistrationType } from "@/types/pre_configured_registration/registration";
import { CheckCircledIcon, CrossCircledIcon } from "@radix-ui/react-icons";
import { useNavigate } from "react-router-dom";
import { registration_products_list, registration_status_badge } from "./utils";

export const PreConfiguredRegistrationTable = ({ registrations, enable_navigation = true }: { registrations: PreConfiguredRegistrationType[]; enable_navigation?: boolean }) => {
    const { user } = useUser();
    const navigate = useNavigate();
    return (
        <Table>
            <TableHeader>
                <TableRow>
                    <TableHead>Status</TableHead>
                    <TableHead>Prospect</TableHead>
                    <TableHead>Formation(s)</TableHead>
                    <TableHead>Financement</TableHead>
                    <TableHead>Validé</TableHead>
                    {user?.is_manager && <TableHead>Commercial</TableHead>}
                    <TableHead>Création</TableHead>
                </TableRow>
            </TableHeader>
            <TableBody>
                {registrations.map(r => (
                    <TableRow
                        className={enable_navigation ? "cursor-pointer" : ""}
                        onClick={event => {
                            if (enable_navigation) {
                                const to = `/inscriptions/ventes/${r.id}/`;
                                if (event.metaKey || event.ctrlKey) {
                                    const win = window.open(to.toString(), "_blank");
                                    win?.focus();
                                } else {
                                    navigate(to);
                                }
                            }
                        }}
                    >
                        <TableCell>{registration_status_badge(r)}</TableCell>
                        <TableCell>
                            {r.first_name} {r.last_name}
                        </TableCell>
                        <TableCell>{registration_products_list(r)}</TableCell>
                        <TableCell>{r.funding_organism?.name}</TableCell>
                        <TableCell>{r.validated ? <CheckCircledIcon className="h-4 w-4 text-green-500" /> : <CrossCircledIcon className="h-4 w-4 text-red-500" />}</TableCell>
                        {user?.is_manager && <TableCell>{r.sales_manager ? display_owner(r.sales_manager) : r.owner ? display_user(r.owner) : ""}</TableCell>}
                        <TableCell>{<Since dt={r.created_at!} />}</TableCell>
                    </TableRow>
                ))}
            </TableBody>
        </Table>
    );
};
